import { UpgradeCTAContainer, PostProfileCTAText, CTAButtonContainer, CTAButton } from './Styled'
import { MainLoadingSkeleton } from 'components/Directories/Styled'

const UpgradeCTA = ({ profileEligibleForUpgrade, isSubscribed, hasListing, isLoading }) => {
  if (profileEligibleForUpgrade && isSubscribed === false && hasListing) {
    if (isLoading === false) {
      return (
        <UpgradeCTAContainer>
          <PostProfileCTAText
            display={{ _: 'block', desktop: 'inline-block' }}
            padding='1rem'
            fontSize='20px'
            m='0px'
            width={{ _: 'auto', desktop: '65%' }}
            verticalAlign='middle'
          >
            Get messages & calls from potential employees
          </PostProfileCTAText>
          <CTAButtonContainer
            display={{ _: 'block', desktop: 'inline-block' }}
            margin={{ _: 'auto', desktop: 0 }}
            width={{ _: '14rem', desktop: '16rem' }}
          >
            <CTAButton
              href='/upgrade?type=directory-banner'
              display='block'
              fontSize='16px'
              padding='1rem'
              maxWidth='16rem'
              mb='0px'
            >
              Upgrade
            </CTAButton>
          </CTAButtonContainer>
        </UpgradeCTAContainer>
      )
    } else {
      return (
        <MainLoadingSkeleton
          minWidth={{ _: '290px', tablet: '345px', desktop: '945px' }}
          minHeight={{ _: '200px', tablet: '205px', desktop: '135px' }}
        />
      )
    }
  }
  return null
}

export default UpgradeCTA
